module.exports = __webpack_public_path__ + "files/6d5fbf75dc271938d204988c417c096b.png";